var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('thead',_vm._l((_vm.columns),function(column){return _c('th',{key:column.field,class:[
        'heading-1',
        { 'text-left': column?.align === 'left' },
        { 'text-right': column?.align === 'right' },
      ]},[_vm._v(" "+_vm._s(column.name)+" ")])}),0),_c('tbody',_vm._l((_vm.data),function(item,index){return _c('tr',{key:index},_vm._l((_vm.columns),function(column){return _c('td',{key:column.field},[_vm._t(column.field,function(){return [_vm._v(" "+_vm._s(item[column.field])+" ")]},{"item":item})],2)}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }